import {
  UilAnalytics,
  UilBrushAlt,
  UilCube,
  UilFileCheck,
  UilNotes,
  UilStore,
  UilTruck,
  UilEstate,
} from '@iconscout/react-unicons'
import { useTheme } from 'styled-components'
import PropTypes from 'prop-types'

const ServiceIcon = ({ Icon, size, color }) => {
  const theme = useTheme()
  return (
    <Icon
      size={size ?? '21'}
      color={color ?? theme.custom_white ?? '#F1B44C'}
      style={{ margin: '-5px' }}
    />
  )
}

ServiceIcon.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
}

export const SERVICES = [
  {
    id: '63dcfb10f81b69c6d3a7c431',
    icon: <ServiceIcon Icon={UilFileCheck} />,
    servicename: 'service.feasibility_check.name',
    serviceInfo: 'service.feasibility_check.service_description',
    attributeKeys: ['Feasibility Check', 'fc_Order Part'],
    getStatus: (value, serviceKey) =>
      serviceKey === 'fc_Order Part' ? 1 : Number(value),
  },
  {
    id: 'main',
    icon: <ServiceIcon Icon={UilEstate} />,
    servicename: 'service.prepare_for_digital_warehousing',
    serviceInfo: 'service.prepare_for_digital_warehousing_description',
    subservices: [
      {
        id: '6405eed3cebc2701ca6c4967',
        icon: <ServiceIcon Icon={UilCube} />,
        servicename: 'service.generate_3d_model.name',
        serviceInfo: 'service.generate_3d_model.service_description',
        attributeKeys: ['Generate 3D Model'],
      },
      {
        id: '63dcfb01f81b69c6d3a7c42e',
        icon: <ServiceIcon Icon={UilBrushAlt} />,
        servicename: 'service.apply_texturing.name',
        serviceInfo: 'service.apply_texturing.service_description',
        attributeKeys: ['Apply Texturing'],
      },
      {
        id: '63dcfaf1f81b69c6d3a7c42d',
        icon: <ServiceIcon Icon={UilStore} />,
        servicename: 'service.apply_branding.name',
        serviceInfo: 'service.apply_branding.service_description',
        attributeKeys: ['Apply Branding'],
      },
    ],
  },
  {
    id: '63dcfac9f81b69c6d3a7c42b',
    icon: <ServiceIcon Icon={UilNotes} />,
    servicename: 'service.request_am_offer.name',
    serviceInfo: 'service.request_am_offer.service_description',
    attributeKeys: ['Request AM Offer'],
  },
  {
    id: '63dcfb10f81b69c6d3a7c42f',
    icon: <ServiceIcon Icon={UilTruck} />,
    servicename: 'service.order_part.name',
    serviceInfo: 'service.order_part.service_description',
    attributeKeys: ['Order Part'],
  },
  {
    id: '63dcfb24f81b69c6d3a7c430',
    icon: <ServiceIcon Icon={UilAnalytics} />,
    servicename: 'service.digital_part_report.name',
    serviceInfo: 'service.digital_part_report.service_description',
    attributeKeys: ['Digital Parts Report'],
    demo: true,
  },
]

export const SESSION_EXPIRED = 'session_expired'
export const AUTOMATIC_LOGOUT = 'automatic_logout'
export const LOGOUT_FLAGS = [SESSION_EXPIRED, AUTOMATIC_LOGOUT]

export const REDIRECT_PARAM = 'redirect'

export const ORDERPARTS_STORAGE_KEY = 'orderPartsWizardState'
export const MATERIAL_FILTER_PARAM = 'material_id'

export const ACCEPTED_BUMPMAP_FILE_TYPES = [
  '.png',
  '.jpg',
  '.jpeg',
  '.tif',
  '.tiff',
  '.svg',
  '.dxf',
  '.dwg',
  '.pdf',
  '.txt',
  '.csv',
  '.json',
  '.xml',
  '.yml',
  '.yaml',
]

export const IMAGE_FORMATS = 'PNG, TIFF, JPEG/JPG'
export const GRAPHIC_FORMATS = 'SVG, DXF, DWG, PDF'
export const TEXT_FORMATS = 'TXT, CSV, JSON, XML, YML'
